export default __webpack_public_path__ + "static/media/learose4-1920w.e24871d7.avif";